import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import "./legal.css";

function AvisoLegal() {
    return (
        <>
            <Navbar />
            
            <div className="legal-page">
                <div className="legal-container">

                    <Link to="/" className="back-btn">
                        ← Volver al inicio
                    </Link>

                    <h1>Aviso Legal</h1>

                    <p>
                        En cumplimiento con la Ley 34/2002 de Servicios de la Sociedad de la
                        Información y del Comercio Electrónico (LSSI-CE), se informa:
                    </p>

                    <h2>Datos identificativos</h2>

                    <p><strong>Titular:</strong> María Fernanda Duarte Abril</p>
                    <p><strong>Nombre comercial:</strong> Limpiezas Costa Blanca</p>
                    <p><strong>Domicilio:</strong> Benidorm, Alicante, España</p>
                    <p><strong>Teléfono:</strong> +34 611 00 98 14</p>
                    <p><strong>Email:</strong> info@limpiezacostablanca.com</p>
                    <p><strong>Email alternativo:</strong> mfda.1396@gmail.com</p>

                    <h2>Condiciones de uso</h2>

                    <p>
                        El acceso y uso del sitio web atribuye la condición de usuario,
                        aceptando las condiciones aquí reflejadas.
                    </p>

                    <p>
                        El usuario se compromete a hacer un uso adecuado de la web y a no
                        emplearla para actividades ilícitas o contrarias a la legislación vigente.
                    </p>

                    <h2>Propiedad intelectual</h2>

                    <p>
                        Todos los contenidos del sitio web, incluyendo textos, imágenes,
                        logotipos, diseño y código son propiedad de Limpiezas Costa Blanca.
                    </p>

                    <h2>Responsabilidad</h2>

                    <p>
                        El titular no se responsabiliza del mal uso del contenido del sitio web
                        ni de problemas técnicos ajenos a su control.
                    </p>

                    <h2>Legislación aplicable</h2>

                    <p>
                        La relación entre el usuario y el titular se regirá por la normativa
                        vigente en España.
                    </p>

                </div>
            </div>
            <Footer />
        </>
    );
}

export default AvisoLegal;